<template>
    <DFormRow
        :label="__('customers.contracts.prompt_cash_discount_days')"
        :error="errors.prompt_cash_discount_days"
    >
        <div
            role="group"
            class="form-group"
        >
            <DInput
                id="prompt_cash_discount_days"
                :model-value="modelValue"
                type="number"
                min="0"
                @update:modelValue="emit('update:modelValue', $event)"
                @update:checked="promptCashDiscountDaysChanged"
            />
        </div>
    </DFormRow>
</template>

<script setup>
defineProps({
    modelValue: {
        type: String,
        default: null
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

const emit = defineEmits(['promptCashDiscountDaysChanged', 'update:modelValue'])

function promptCashDiscountDaysChanged (value) {
    emit('promptCashDiscountDaysChanged', value)
}
</script>
